import { useVehicleAvailability } from '~/context/vdp/UserVehicleContext';

export default function useVehicleAvailableDateTime() {
  const { vehicleAvailableDateTime } = useVehicleAvailability();

  return vehicleAvailableDateTime ? Date.parse(vehicleAvailableDateTime) : null;
}
